import React from "react";
import "./register.css";

const Register = () => {
  const requests = [
    { id: 1, name: "User_Name", type: "Civil Lawyer" },
    { id: 2, name: "User_Name", type: "Criminal Lawyer" },
  ];

  return (
    <div className="register-container">
      <h2>Register the Users</h2>
      <div className="request-list">
        {requests.map((request) => (
          <div key={request.id} className="request-card">
            <span className="request-info">
              {request.name} - {request.type}
            </span>
            <button className="btn view">View</button>
            <button className="btn accept">Accept</button>
            <button className="btn ignore">Ignore</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Register;
